import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';
import { serializeQueryString } from 'Util/fetcher';

function getUrl(code) {
  if (!code) return 'v1/stock/odt/balance/';

  const query = serializeQueryString({ code });
  return `v1/stock/odt/balance/stock-haircut/${query}`;
}

/**
 * @param {string} url
 * @returns
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url);

      return res.data?.result;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {?string} stockCode
 */
export default function fetch(stockCode) {
  const url = getUrl(stockCode);

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
